import {Alert as AntAlert} from "antd";

export const Alert = AntAlert;
export default Alert;
